export const validateMinMaxRange = (min, max) => {
  const errors = { min: "", max: "" };

  if (min === "" || min === null) return errors;
  if (max === "" || max === null) return errors;

  const minVal = Number(min);
  const maxVal = Number(max);

  if (Number.isNaN(minVal) || Number.isNaN(maxVal)) return errors;

  // only invalid when max is less than min
  if (maxVal < minVal) {
    errors.max = "Max value should be greater than or equal to Min value";
  }

  return errors;
};

export const validateBudgetRange = (min, max) => {
  const errors = { min: "", max: "" };

  if (min && Number(min) < 1000) {
    errors.min = "Minimum budget should be at least ₹1000";
  }

  if (min && max && Number(max) <= Number(min)) {
    errors.max = "Max budget should be greater than Min budget";
  }

  return errors;
};

const MIN_BUDGET = 1000;

export const validateSingleBudget = (budget) => {
  if (budget === "" || budget === null) return "";

  const val = Number(budget);
  if (Number.isNaN(val)) return "";

  if (val < MIN_BUDGET) {
    return "Budget should be at least ₹1000";
  }

  return "";
};
